import SelectPanel from 'components/SelectPanel';
import SingleSelectItem from 'components/SingleSelectItem';

import useTranslation from './hooks/useTranslation';

import { DEBOUNCE_DEFAULT_TIME, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const SingleSelectPanel: FunctionComponent<Props> = ({
    className = '',
    debounceTime = DEBOUNCE_DEFAULT_TIME,
    entityType,
    getSectionKey,
    hasNextPage,
    isLoading,
    isSearchable,
    itemSelected,
    items,
    label,
    noItemsFoundText,
    onFilter,
    onNextPage,
    onSelected,
    sections,
    testId = TEST_ID
}) => {
    const { CHOOSE_ONE } = useTranslation();

    return (
        <SelectPanel
            className={className}
            debounceTime={debounceTime}
            getSectionKey={getSectionKey}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            isSearchable={isSearchable}
            items={items}
            label={label}
            labelText={CHOOSE_ONE(entityType)}
            noItemsFoundText={noItemsFoundText}
            onFilter={onFilter}
            onNextPage={onNextPage}
            sections={sections}
            testId={testId}>
            {item => (
                <SingleSelectItem
                    item={item}
                    itemSelected={itemSelected}
                    key={item.value}
                    onClick={() => onSelected(item)}
                />
            )}
        </SelectPanel>
    );
};

export default SingleSelectPanel;
